import * as React from 'react';

export interface IInfoMessageProps {
    children: React.ReactNode;
}

export const InfoMessage = (props: IInfoMessageProps) => {
    return <div className="ml-2">{ props.children }</div>
}